// src/firebase.js
// ─────────────────────────────────────────────────────────────
// Add your Firebase project credentials below.
// Find them in: Firebase Console → Project Settings → Your Apps
// ─────────────────────────────────────────────────────────────
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA9WKoNPIB5dlsFqtq4gK5HAgTno3-tlBc",
    authDomain: "berlibrewingcom.firebaseapp.com",
    projectId: "berlibrewingcom",
    storageBucket: "berlibrewingcom.firebasestorage.app",
    messagingSenderId: "13540095259",
    appId: "1:13540095259:web:e6af8d1ee344ca3c274fbe",
    measurementId: "G-2541C9YM37"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
